window.COFFEE_COUNTRIES = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "id": "ETH",
        "name": "Ethiopia",
        "level": 2,
        "parent": "WORLD",
        "summary": "Explore Ethiopia and its remarkable coffee-growing regions.",
        "hasChildren": true
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [47.78942,8.003],
          [44.9636,5.00162],
          [43.66087,4.95755],
          [42.76967,4.25259],
          [42.12861,4.23413],
          [41.855083,3.918912],
          [41.1718,3.91909],
          [40.76848,4.25702],
          [39.85494,3.83879],
          [39.559384,3.42206],
          [38.89251,3.50074],
          [38.67114,3.61607],
          [38.43697,3.58851],
          [38.120915,3.598605],
          [36.855093,4.447864],
          [36.159079,4.447864],
          [35.817448,4.776966],
          [35.817448,5.338232],
          [35.298007,5.506],
          [34.70702,6.59422],
          [34.25032,6.82607],
          [34.0751,7.22595],
          [33.56829,7.71334],
          [32.95418,7.78497],
          [33.2948,8.35458],
          [33.8255,8.37916],
          [33.97498,8.68456],
          [33.96162,9.58358],
          [34.25745,10.63009],
          [34.73115,10.91017],
          [34.83163,11.31896],
          [35.26049,12.08286],
          [35.86363,12.57828],
          [36.27022,13.56333],
          [36.42951,14.42211],
          [37.59377,14.2131],
          [37.90607,14.95943],
          [38.51295,14.50547],
          [39.0994,14.74064],
          [39.34061,14.53155],
          [40.02625,14.51959],
          [40.8966,14.11864],
          [41.1552,13.77333],
          [41.59856,13.45209],
          [42.00975,12.86582],
          [42.35156,12.54223],
          [42.0,12.1],
          [41.66176,11.6312],
          [41.73959,11.35511],
          [41.75557,11.05091],
          [42.31414,11.0342],
          [42.55493,11.10511],
          [42.776852,10.926879],
          [42.55876,10.57258],
          [42.92812,10.02194],
          [43.29699,9.54048],
          [43.67875,9.18358],
          [46.94834,7.99688],
          [47.78942,8.003]
        ]]
      }
    }
  ]
};